export const PORTFOLIO = [
  {
    slug: "nimbus-cloud-erp",
    title: "Nimbus — Cloud ERP for Manufacturing",
    industry: "Manufacturing",
    overview: "A unified ERP replacing five legacy systems for a 4,000-employee manufacturer. Real-time OEE, MRP and finance modules running on a modern event-driven core.",
    tech: ["React", "Node.js", "PostgreSQL", "Kafka", "AWS"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "37%", v: "OEE Improvement" }, { k: "5→1", v: "Systems Consolidated" }, { k: "4 mo", v: "To First Plant Live" }],
  },
  {
    slug: "vault-fintech-ledger",
    title: "Vault — Real-time FinTech Ledger",
    industry: "FinTech",
    overview: "A double-entry ledger engine handling 12M transactions per day with sub-50ms p99 settlement latency for a Series C neobank.",
    tech: ["Go", "PostgreSQL", "Redis", "Kafka", "Kubernetes"],
    image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "12M/day", v: "Transactions" }, { k: "42ms", v: "p99 Latency" }, { k: "99.99%", v: "Uptime" }],
  },
  {
    slug: "lumen-ai-radiology",
    title: "Lumen — AI Radiology Assistant",
    industry: "Healthcare",
    overview: "A FDA-pathway computer vision platform that flags critical findings on chest X-rays in under 8 seconds, deployed across 22 hospitals.",
    tech: ["PyTorch", "FastAPI", "DICOM", "AWS HealthLake"],
    image: "https://images.unsplash.com/photo-1686061594225-3e92c0cd51b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "97.2%", v: "Sensitivity" }, { k: "8s", v: "Time-to-Insight" }, { k: "22", v: "Hospitals Live" }],
  },
  {
    slug: "atlas-logistics",
    title: "Atlas — Last-Mile Logistics OS",
    industry: "Logistics",
    overview: "A driver app and dispatcher console that optimizes 18,000 daily routes across 14 cities. Built-in AI ETA prediction and proof-of-delivery.",
    tech: ["React Native", "Node.js", "MongoDB", "Mapbox", "GCP"],
    image: "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "23%", v: "Fuel Saved" }, { k: "18K", v: "Routes/Day" }, { k: "+14 NPS", v: "Driver Satisfaction" }],
  },
  {
    slug: "scholar-ai-tutor",
    title: "Scholar — Adaptive AI Tutor",
    industry: "Education",
    overview: "An LLM-powered tutoring app that personalizes lessons in 11 languages. Serves 1.2M learners with on-device guardrails and parent dashboards.",
    tech: ["Next.js", "Anthropic Claude", "Pinecone", "Supabase"],
    image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "1.2M", v: "Active Learners" }, { k: "+34%", v: "Test Score Lift" }, { k: "11", v: "Languages" }],
  },
  {
    slug: "halo-multiplayer",
    title: "Halo Arena — Mobile Multiplayer",
    industry: "Gaming",
    overview: "A 4v4 real-time mobile shooter with 80ms global netcode, cross-platform progression and a live-ops calendar driving 38% D30 retention.",
    tech: ["Unity", "Photon", "AWS GameLift", "PlayFab"],
    image: "https://images.unsplash.com/photo-1526657782461-9fe13402a841?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "2.4M", v: "Installs Mo1" }, { k: "38%", v: "D30 Retention" }, { k: "80ms", v: "Global Netcode" }],
  },
  {
    slug: "verdant-agritech",
    title: "Verdant — Agritech Vision Platform",
    industry: "Agritech",
    overview: "Drone + satellite imagery pipeline that detects crop disease 11 days earlier than visual inspection, across 240K hectares.",
    tech: ["Python", "PyTorch", "GDAL", "Kubernetes", "GCP"],
    image: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "11 days", v: "Earlier Detection" }, { k: "240K ha", v: "Coverage" }, { k: "17%", v: "Yield Increase" }],
  },
  {
    slug: "concierge-hospitality",
    title: "Concierge — Hotel Guest OS",
    industry: "Hospitality",
    overview: "A guest super-app and PMS integration deployed across a 38-property chain. Contactless check-in, smart-room controls and upsell automation.",
    tech: ["React Native", "Node.js", "PostgreSQL", "Twilio", "Stripe"],
    image: "https://images.unsplash.com/photo-1471897488648-5eae4ac6686b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    metrics: [{ k: "62%", v: "App Adoption" }, { k: "$184", v: "Upsell / Stay" }, { k: "38", v: "Properties" }],
  },
];
